// extracted by mini-css-extract-plugin
export default {"-large":"krUBPSCclYpOlVbg7TU_","notifyContainer":"PrgsILapw6Wcbja9atNR","notifyText":"mlAOXZDj10_mWo78bTip"};